import React, { Component } from 'react'
import All from './all'
import HighIntention from './high_intention'
import NoFollowUp from './no_followup'
import NotConnected from './not_connected'
import Toshop from './to_shop'
import Refund from './refund'
import store from '../store'
import { Tabs } from 'hljd'
import { observer } from 'mobx-react'
import Styles from './style.module.less'

const TabPane = Tabs.TabPane

@observer
export default class extends Component {
  render() {
    return (
      <div>
        <div className={Styles.orderBox}>
          <Tabs
            activeKey={store.tabkey}
            onChange={store.callback}
            type="card"
            style={{ marginTop: 30 }}
          >
            <TabPane tab="全部" key="all">
              <All />
            </TabPane>
            <TabPane tab="高意向" key="level_high">
              <HighIntention />
            </TabPane>
            <TabPane tab="未跟进" key="not_following">
              <NoFollowUp />
            </TabPane>
            <TabPane tab="拨打未接通" key="not_connected">
              <NotConnected />
            </TabPane>
            <TabPane tab="已到店" key="is_come">
              <Toshop />
            </TabPane>
            <TabPane tab="退单" key="refund">
              <Refund />
            </TabPane>
          </Tabs>
        </div>
      </div>
    )
  }
}
